import { SearchConst } from '../../search/search.const';

export class ChatBoxConst {
  static displayHeadStatus = status => {
    return SearchConst.displayStatusColumns({ status: status });
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/chat/chat-box/chat.const.ts